@if (DataService.SelectedDraw && (DataService.SelectedDraw?.Matches?.length == 0 || isEditingDraws == true)) {
  <div class="playerList">
    @if (DataService.SelectedDraw.theEventID == 0 || isEditingDraws == true) {
      <div style="margin: 20px;">
        <label>Draw Name:</label>
        <input type="text" [(ngModel)]="DataService.SelectedDraw.name" class="drawNameInput" (lostfocus)="updateDrawType()"/>
      </div>
    }
    @if (DataService.SelectedDraw.theEventID == 0) {
      <div style="margin: 20px;">
        <label>Gender:</label>
        <mat-radio-group [(ngModel)]="DataService.SelectedDraw.gender" class="genderRadioGroup">
          <mat-radio-button value="M">Male</mat-radio-button>
          <mat-radio-button value="F">Female</mat-radio-button>
          <mat-radio-button value="U">Unisex</mat-radio-button>
        </mat-radio-group>
      </div>
    }
    @if ((DataService.SelectedDraw.theEventID == 0 && DataService.SelectedDraw.name != 'new' && DataService.SelectedDraw.id > 0) || isEditingDraws == true) {
      <div style="margin: 20px;">
        <label>Select Event for Draw:</label>
        <select [(ngModel)]="DataService.SelectedDraw.theEvent" (ngModelChange)="EventForDrawChanged(DataService.SelectedDraw.theEvent.id)" class="eventSelect">
          <!-- <option value="0">Select Event</option> -->
          @for (event of DataService.SelectedTorn.events; track event) {
            <option [ngValue]="event">
              {{event.name}} - {{event.type}}
            </option>
          }
        </select>
      </div>
    }
    @if ((DataService.SelectedDraw.theEventID > 0 && DataService.SelectedDraw.name != 'new' && DataService.SelectedDraw.type == '') || isEditingDraws == true) {
      <div style="margin: 20px;">
        <label>Draw Type:</label>
        <select [(ngModel)]="DataService.SelectedDraw.type" (ngModelChange)="updateDrawType()" class="drawTypeSelect">
          <option value="Singles">Singles</option>
          <option value="Doubles">Doubles</option>
        </select>
      </div>
    }
    @if (isEditingDraws == true) {
      <mat-button style="padding: 5px 10px;" type="button" class="edit-toggle-btn" (click)="updateDrawType()">
        Update Draw
      </mat-button>
    }
    @if (isEditingDraws == true && DataService.SelectedDraw.Matches.length > 0) {
      <mat-button style="padding: 5px 10px;" type="button" class="edit-toggle-btn" (click)="FunctionService.deleteMatches()">
        Delete Matches
      </mat-button>
    }
    @if (DataService.SelectedDraw.theEventID > 0 && DataService.SelectedDraw.name != 'new' && DataService.SelectedDraw.type != '') {
      <div style="display: flex">
        <div style="min-width: 400px; min-height: 400px; margin: 20px">
          @if (DataService.SelectedDraw?.AvailablePlayers?.length > 0) {
            <h2>Players {{DataService.SelectedDraw?.AvailablePlayers?.length}}</h2>
          }
          @if (DataService.SelectedDraw?.AvailablePlayers?.length > 0) {
            <table class="playerListTable">
              <thead>
                <tr>
                  <th>Players</th>
                  <th>Points</th>
                  <!-- <th>alter</th> -->
                </tr>
              </thead>
              <tbody>
                @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                  <tr>
                    <td style="text-align: center;">{{player.name}} {{DataService.SelectedDraw.type == 'Doubles' ? '/' + FunctionService.getPartnerFromPlayer(player.id, DataService.SelectedDraw.theEventID)?.name : '' }}</td>
                    <td style="text-align: center;">{{DataService.SelectedDraw.type == 'Doubles' ? FunctionService.getEventForPlayer(player.id, DataService.SelectedDraw.theEventID)?.DoublesTotalPoints : player.singlesPoints}}</td>
                    <!-- <td style="text-align: center;">
                    <mat-button type="button" class="Arrows" (click)="Up(player)" >▲</mat-button>
                    <mat-button type="button" class="Arrows" (click)="Down(player)" >▼</mat-button>
                  </td> -->
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
      <div>
        @if (DataService.SelectedDraw.AvailablePlayers?.length < 26 || (DataService.SelectedDraw.AvailablePlayers?.length < 13 && DataService.SelectedDraw.type == 'Singles')) {
          <input type="checkbox" id="MustBeRR" name="MustBeRR" [(ngModel)]="MustBeRR" (ngModelChange)="onRRChanged($event)" />
          <label for="MustBeRR">Must be Round Robin</label>
        }
        <br>
        @if (DataService.SelectedDraw.AvailablePlayers?.length > 3 && ((DataService.SelectedDraw.AvailablePlayers?.length < 13 && DataService.SelectedDraw.type == 'Singles') || (DataService.SelectedDraw.AvailablePlayers?.length < 26 && DataService.SelectedDraw.type == 'Doubles'))) {
          <input type="checkbox" id="MustBeKO" name="MustBeKO" [(ngModel)]="MustBeKO" (ngModelChange)="onKOChanged($event)" />
          <label for="MustBeKO">Must be a Knockout Draw</label>
        }
        <br>
        @if (AllowTornUpdate) {
          <button class="btn-action" (click)="CreateMatchesForDraw()" [disabled]="(DataService.SelectedDraw?.AvailablePlayers?.length ?? 0) < 3">Create Matches</button>
        }
        </div>
      </div>
      }
    </div>
  }

  @if (DataService.SelectedDraw?.Matches?.length > 0) {
    <div class="Draw-wrapper">
      @if (DataService.SelectedDraw.format === 'KO' && isKOReady == true) {
        <div id="KODrawContainer" class="KODrawContainer">
          @if (DataService.SelectedDraw.AvailablePlayers.length == 4) {
            <app-draw [MatchesKO4]="DataService.SelectedDraw.Matches" style="width: 100%; display: flex"></app-draw>
          }
          @if (DataService.SelectedDraw.AvailablePlayers.length == 8) {
            <app-draw [MatchesKO8]="DataService.SelectedDraw.Matches" style="width: 100%; display: flex"></app-draw>
          }
          @if (DataService.SelectedDraw.AvailablePlayers.length > 8 && DataService.SelectedDraw.AvailablePlayers.length < 17) {
            <app-draw [MatchesKO16]="DataService.SelectedDraw.Matches" style="width: 100%; display: flex"></app-draw>
          }
          @if (DataService.SelectedDraw.AvailablePlayers.length > 16 && DataService.SelectedDraw.AvailablePlayers.length < 33  && DataService.SelectedDraw.Matches.length > 80) {
            <app-draw [MatchesKO32]="DataService.SelectedDraw.Matches" style="width: 100%; display: flex"></app-draw>
          }
          <!-- <div class="KO4Player" style="width: 100%" *ngIf="DataService.SelectedDraw.AvailablePlayers.length == 4">
          <div class="TreeLine LineRound1" id="KOLine{{i + 1}}1" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf="i < 2">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <div class="TreeLine LineRound1" id="KOLine{{i + 1}}2" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf="i < 2">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine LineFinal" id="KOLineF1" *ngFor="let o of Round2Array; let i = index" >
            <div *ngIf="i == 0">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <div class="TreeLine LineFinal" id="KOLineF2" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf="i == 0">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine LinePlate" id="KOLine{{i + 1}}1L" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf="i < 2">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine LinePlate" id="KOLine{{i + 1}}2L" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf="i < 2">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <div class="TreeLine LinePlateFinal" id="KOLineF1L" *ngFor="let o of Round2Array; let i = index" >
            <div *ngIf="i == 0">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine LinePlateFinal" id="KOLineF2L" *ngFor="let o of Round2Array; let i = index" >
            <div *ngIf="i == 0">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <label class="KODrawLabels" id="KODrawLabel">Main Draw</label>
          <label class="KODrawLabels" id="PlateDrawLabel">Plate Draw</label>
        </div>
        <div class="KO8Player" *ngIf="DataService.SelectedDraw.AvailablePlayers.length == 7">
          <div class="TreeLine newLineRound1" id="KOLine{{i + 1}}1" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf=" i < 2">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <div class="TreeLine newLineRound1" id="KOLine{{i + 1}}2" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf="i < 2">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine newLineRound2" id="KOLine{{i + 5}}1" *ngFor="let o of Round2Array; let i = index" >
            <div *ngIf=" i == 0">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <div class="TreeLine newLineRound2" id="KOLine{{i + 5}}2" *ngFor="let o of Round2Array; let i = index" >
            <div *ngIf=" i == 0">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine newLLine1" id="KOLine{{i + 1}}1L" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf=" i < 2">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine newLLine1" id="KOLine{{i + 1}}2L" *ngFor="let o of RepeatArray; let i = index" >
            <div *ngIf="i < 2">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <div class="TreeLine newLLine2" id="KOLine{{i + 5}}1L" *ngFor="let o of Round2Array; let i = index" >
            <div *ngIf="i == 0">
              <div class="knockoutTreeLine topLeft"></div>
              <div class="knockoutTreeLine bottomRight"></div>
            </div>
          </div>
          <div class="TreeLine newLLine2" id="KOLine{{i + 5}}2L" *ngFor="let o of Round2Array; let i = index" >
            <div *ngIf="i == 0">
              <div class="knockoutTreeLine topRight"></div>
              <div class="knockoutTreeLine bottomLeft"></div>
            </div>
          </div>
          <img id="cup" src="/assets/images/Cup.png" />
          <label class="KODrawLabels" id="KODrawLabel">Main Draw</label>
          <label class="KODrawLabels" id="PlateDrawLabel">Plate Draw</label>
          <label class="KODrawLabels" id="SpecialDrawLabel">Special Plate</label>
          <label class="KODrawLabels" id="ConsDrawLabel">Consolation Plate</label>
        </div> -->
        <!-- <div class="KO16Player" *ngIf="DataService.SelectedDraw.AvailablePlayers.length == 15">
        <div class="TreeLine newLineRound1" id="KOLine{{i + 1}}1" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topRight"></div>
            <div class="knockoutTreeLine bottomLeft"></div>
          </div>
        </div>
        <div class="TreeLine newLineRound1" id="KOLine{{i + 1}}2" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topLeft"></div>
            <div class="knockoutTreeLine bottomRight"></div>
          </div>
        </div>
        <div class="TreeLine newLineRound2" id="KOLine{{i + 5}}1" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topRight"></div>
            <div class="knockoutTreeLine bottomLeft"></div>
          </div>
        </div>
        <div class="TreeLine newLineRound2" id="KOLine{{i + 5}}2" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topLeft"></div>
            <div class="knockoutTreeLine bottomRight"></div>
          </div>
        </div>
        <div class="TreeLine newLLine1" id="KOLine{{i + 1}}1L" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topLeft"></div>
            <div class="knockoutTreeLine bottomRight"></div>
          </div>
        </div>
        <div class="TreeLine newLLine1" id="KOLine{{i + 1}}2L" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topRight"></div>
            <div class="knockoutTreeLine bottomLeft"></div>
          </div>
        </div>
        <div class="TreeLine newLLine2" id="KOLine{{i + 5}}1L" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topLeft"></div>
            <div class="knockoutTreeLine bottomRight"></div>
          </div>
        </div>
        <div class="TreeLine newLLine2" id="KOLine{{i + 5}}2L" *ngFor="let i of [].constructor(2); let i = index" >
          <div>
            <div class="knockoutTreeLine topRight"></div>
            <div class="knockoutTreeLine bottomLeft"></div>
          </div>
        </div>
        <img id="cup" src="/assets/images/Cup.png" />
        <label class="KODrawLabels" id="KODrawLabel">Main Draw</label>
        <label class="KODrawLabels" id="PlateDrawLabel">Plate Draw</label>
        <label class="KODrawLabels" id="SpecialDrawLabel">Special Plate</label>
        <label class="KODrawLabels" id="ConsDrawLabel">Consolation Plate</label>
      </div>
    </div> -->
  </div>
}
@if (DataService.SelectedDraw.format === 'RR') {
  <div class="rr-page">
    <section class="panel rr-matrix">
      <h3>Round Robin</h3>
      @if (isRRReady) {
        <table>
          <thead id="THead">
            <tr>
              <th></th>
              <th class="drawTitle">{{DataService.SelectedDraw.name}}</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              @if (DataService.SelectedDraw.Players1.length > 3) {
                <th>4</th>
              }
              @if (DataService.SelectedDraw.Players1.length > 4) {
                <th>5</th>
              }
              @if (DataService.SelectedDraw.Players1.length > 5) {
                <th>6</th>
              }
            </tr>
          </thead>
          @if (RRMatches) {
            <tbody id="TableBody1" #TableBody1>
              <tr>
                <td>1</td>
                <td>{{DataService.SelectedDraw.Players1[0]?.name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                  <span>/{{FunctionService.getPartnerFromPlayer(DataService.SelectedDraw.Players1[0].id, DataService.SelectedDraw.theEventID)?.name}}</span>
                }</td>
                <td class="Gray"></td>
                @if (RRMatches?.[1]?.[2]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[1]?.[2].matchNo, 1)" (click)="EnterScore(RRMatches?.[1]?.[2].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[1]?.[2]?.MatchScore ?? RRMatches?.[1]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[1]?.[3]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[1]?.[3].matchNo, 1)" (click)="EnterScore(RRMatches?.[1]?.[3].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[1]?.[3]?.MatchScore ?? RRMatches?.[1]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[1]?.[4]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[1]?.[4].matchNo, 1)" (click)="EnterScore(RRMatches?.[1]?.[4].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[1]?.[4]?.MatchScore ?? RRMatches?.[1]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[1]?.[5]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[1]?.[5].matchNo, 1)" (click)="EnterScore(RRMatches?.[1]?.[5].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[1]?.[5]?.MatchScore ?? RRMatches?.[1]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[1]?.[6]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[1]?.[6].matchNo, 1)" (click)="EnterScore(RRMatches?.[1]?.[6].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[1]?.[6]?.MatchScore ?? RRMatches?.[1]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
              </tr>
              <tr>
                <td>2</td>
                <td>{{DataService.SelectedDraw.Players1[1]?.name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                  <span>/{{FunctionService.getPartnerFromPlayer(DataService.SelectedDraw.Players1[1].id, DataService.SelectedDraw.theEventID)?.name}}</span>
                }</td>
                @if (RRMatches?.[2]?.[1]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[2]?.[1].matchNo, 1)" (click)="EnterScore(RRMatches?.[2]?.[1].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[2]?.[1]?.MatchScore ?? RRMatches?.[2]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                <td class="Gray"></td>
                @if (RRMatches?.[2]?.[3]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[2]?.[3].matchNo, 1)" (click)="EnterScore(RRMatches?.[2]?.[3].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[2]?.[3]?.MatchScore ?? RRMatches?.[2]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[2]?.[4]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[2]?.[4].matchNo, 1)" (click)="EnterScore(RRMatches?.[2]?.[4].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[2]?.[4]?.MatchScore ?? RRMatches?.[2]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[2]?.[5]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[2]?.[5].matchNo, 1)" (click)="EnterScore(RRMatches?.[2]?.[5].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[2]?.[5]?.MatchScore ?? RRMatches?.[2]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[2]?.[6]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[2]?.[6].matchNo, 1)" (click)="EnterScore(RRMatches?.[2]?.[6].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[2]?.[6]?.MatchScore ?? RRMatches?.[2]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
              </tr>
              <tr>
                <td>3</td>
                <td>{{DataService.SelectedDraw.Players1[2]?.name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                  <span>/{{FunctionService.getPartnerFromPlayer(DataService.SelectedDraw.Players1[2].id, DataService.SelectedDraw.theEventID)?.name}}</span>
                }</td>
                @if (RRMatches?.[3]?.[1]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[3]?.[1].matchNo, 1)" (click)="EnterScore(RRMatches?.[3]?.[1].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[3]?.[1]?.MatchScore ?? RRMatches?.[3]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[3]?.[2]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[3]?.[2].matchNo, 1)" (click)="EnterScore(RRMatches?.[3]?.[2].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[3]?.[2]?.MatchScore ?? RRMatches?.[3]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                <td class="Gray"></td>
                @if (RRMatches?.[3]?.[4]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[3]?.[4].matchNo, 1)" (click)="EnterScore(RRMatches?.[3]?.[4].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[3]?.[4]?.MatchScore ?? RRMatches?.[3]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[3]?.[5]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[3]?.[5].matchNo, 1)" (click)="EnterScore(RRMatches?.[3]?.[5].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[3]?.[5]?.MatchScore ?? RRMatches?.[3]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches?.[3]?.[6]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[3]?.[6].matchNo, 1)" (click)="EnterScore(RRMatches?.[3]?.[6].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[3]?.[6]?.MatchScore ?? RRMatches?.[3]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
              </tr>
              @if (DataService.SelectedDraw.Players1.length > 3) {
                <tr>
                  <td >4</td>
                  <td>{{DataService.SelectedDraw.Players1[3]?.name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                    <span>/{{FunctionService.getPartnerFromPlayer(DataService.SelectedDraw.Players1[3].id, DataService.SelectedDraw.theEventID)?.name}}</span>
                  }</td>
                  @if (RRMatches?.[4]?.[1]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[4]?.[1].matchNo, 1)" (click)="EnterScore(RRMatches?.[4]?.[1].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[4]?.[1]?.MatchScore ?? RRMatches?.[4]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[4]?.[2]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[4]?.[2].matchNo, 1)" (click)="EnterScore(RRMatches?.[4]?.[2].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[4]?.[2]?.MatchScore ?? RRMatches?.[4]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[4]?.[3]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[4]?.[3].matchNo, 1)" (click)="EnterScore(RRMatches?.[4]?.[3].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[4]?.[3]?.MatchScore ?? RRMatches?.[4]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  <td class="Gray"></td>
                  @if (RRMatches?.[4]?.[5]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[4]?.[5].matchNo, 1)" (click)="EnterScore(RRMatches?.[4]?.[5].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[4]?.[5]?.MatchScore ?? RRMatches?.[4]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[4]?.[6]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[4]?.[6].matchNo, 1)" (click)="EnterScore(RRMatches?.[4]?.[6].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[4]?.[6]?.MatchScore ?? RRMatches?.[4]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                </tr>
              }
              @if (DataService.SelectedDraw.Players1.length > 4) {
                <tr>
                  <td >5</td>
                  <td >{{DataService.SelectedDraw.Players1[4]?.name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                    <span>/{{FunctionService.getPartnerFromPlayer(DataService.SelectedDraw.Players1[4].id, DataService.SelectedDraw.theEventID)?.name}}</span>
                  }</td>
                  @if (RRMatches?.[5]?.[1]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[5]?.[1].matchNo, 1)" (click)="EnterScore(RRMatches?.[5]?.[1].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[5]?.[1]?.MatchScore ?? RRMatches?.[5]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[5]?.[2]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[5]?.[2].matchNo, 1)" (click)="EnterScore(RRMatches?.[5]?.[2].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[5]?.[2]?.MatchScore ?? RRMatches?.[5]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[5]?.[3]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[5]?.[3].matchNo, 1)" (click)="EnterScore(RRMatches?.[5]?.[3].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[5]?.[3]?.MatchScore ?? RRMatches?.[5]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[5]?.[4]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[5]?.[4].matchNo, 1)" (click)="EnterScore(RRMatches?.[5]?.[4].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[5]?.[4]?.MatchScore ?? RRMatches?.[5]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  <td class="Gray"></td>
                  @if (RRMatches?.[5]?.[6]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[5]?.[6].matchNo, 1)" (click)="EnterScore(RRMatches?.[5]?.[6].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[5]?.[6]?.MatchScore ?? RRMatches?.[5]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                </tr>
              }
              @if (DataService.SelectedDraw.Players1.length > 5) {
                <tr>
                  <td >6</td>
                  <td>{{DataService.SelectedDraw.Players1[5]?.name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                    <span>/{{FunctionService.getPartnerFromPlayer(DataService.SelectedDraw.Players1[5].id, DataService.SelectedDraw.theEventID)?.name}}</span>
                  }</td>
                  @if (RRMatches?.[6]?.[1]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[6]?.[1].matchNo, 1)" (click)="EnterScore(RRMatches?.[6]?.[1].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[6]?.[1]?.MatchScore ?? RRMatches?.[6]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[6]?.[2]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[6]?.[2].matchNo, 1)" (click)="EnterScore(RRMatches?.[6]?.[2].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[6]?.[2]?.MatchScore ?? RRMatches?.[6]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[6]?.[3]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[6]?.[3].matchNo, 1)" (click)="EnterScore(RRMatches?.[6]?.[3].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[6]?.[3]?.MatchScore ?? RRMatches?.[6]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[6]?.[4]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[6]?.[4].matchNo, 1)" (click)="EnterScore(RRMatches?.[6]?.[4].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[6]?.[4]?.MatchScore ?? RRMatches?.[6]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches?.[6]?.[5]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches?.[6]?.[5].matchNo, 1)" (click)="EnterScore(RRMatches?.[6]?.[5].matchNo, 1)" (mouseleave)="mouseLeft()">{{ RRMatches?.[6]?.[5]?.MatchScore ?? RRMatches?.[6]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  <td class="Gray"></td>
                </tr>
              }
            </tbody>
          }
        </table>
      }
      @if (isRRReady && DataService.SelectedDraw.Players2?.length > 0) {
        <table style="margin-top: 20px">
          <thead id="THead">
            <tr>
              <th></th>
              <th class="drawTitle">{{DataService.SelectedDraw.name}} - #2</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              @if (DataService.SelectedDraw.Players2.length > 3) {
                <th>4</th>
              }
            </tr>
          </thead>
          @if (RRMatches2) {
            <tbody id="TableBody1" #TableBody1>
              <tr>
                <td>1</td>
                <td>{{DataService.SelectedDraw.Players2[0].name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                  <span>/{{DataService.SelectedDraw.Players2[0].PartnerName}}</span>
                }</td>
                <td class="Gray"></td>
                @if (RRMatches2?.[1]?.[2]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[1]?.[2].matchNo, 2)" (click)="EnterScore(RRMatches2?.[1]?.[2].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[1]?.[2]?.Score ?? RRMatches2?.[1]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches2?.[1]?.[3]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[1]?.[3].matchNo, 2)" (click)="EnterScore(RRMatches2?.[1]?.[3].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[1]?.[3]?.Score ?? RRMatches2?.[1]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches2?.[1]?.[4]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[1]?.[4].matchNo, 2)" (click)="EnterScore(RRMatches2?.[1]?.[4].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[1]?.[4]?.Score ?? RRMatches2?.[1]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches2?.[1]?.[5]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[1]?.[5].matchNo, 2)" (click)="EnterScore(RRMatches2?.[1]?.[5].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[1]?.[5]?.Score ?? RRMatches2?.[1]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
              </tr>
              <tr>
                <td>2</td>
                <td>{{DataService.SelectedDraw.Players2[1].name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                  <span>/{{DataService.SelectedDraw.Players2[1].PartnerName}}</span>
                }</td>
                @if (RRMatches2?.[2]?.[1]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[2]?.[1].matchNo, 2)" (click)="EnterScore(RRMatches2?.[2]?.[1].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[2]?.[1]?.Score ?? RRMatches2?.[2]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                <td class="Gray"></td>
                @if (RRMatches2?.[2]?.[3]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[2]?.[3].matchNo, 2)" (click)="EnterScore(RRMatches2?.[2]?.[3].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[2]?.[3]?.Score ?? RRMatches2?.[2]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches2?.[2]?.[4]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[2]?.[4].matchNo, 2)" (click)="EnterScore(RRMatches2?.[2]?.[4].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[2]?.[4]?.Score ?? RRMatches2?.[2]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches2?.[2]?.[5]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[2]?.[5].matchNo, 2)" (click)="EnterScore(RRMatches2?.[2]?.[5].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[2]?.[5]?.Score ?? RRMatches2?.[2]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
              </tr>
              <tr>
                <td>3</td>
                <td>{{DataService.SelectedDraw.Players2[2].name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                  <span>/{{DataService.SelectedDraw.Players2[2].PartnerName}}</span>
                }</td>
                @if (RRMatches2?.[3]?.[1]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[3]?.[1].matchNo, 2)" (click)="EnterScore(RRMatches2?.[3]?.[1].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[3]?.[1]?.Score ?? RRMatches2?.[3]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches2?.[3]?.[2]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[3]?.[2].matchNo, 2)" (click)="EnterScore(RRMatches2?.[3]?.[2].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[3]?.[2]?.Score ?? RRMatches2?.[3]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                <td class="Gray"></td>
                @if (RRMatches2?.[3]?.[4]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[3]?.[4].matchNo, 2)" (click)="EnterScore(RRMatches2?.[3]?.[4].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[3]?.[4]?.Score ?? RRMatches2?.[3]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
                @if (RRMatches2?.[3]?.[5]) {
                  <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[3]?.[5].matchNo, 2)" (click)="EnterScore(RRMatches2?.[3]?.[5].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[3]?.[5]?.Score ?? RRMatches2?.[3]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                }
              </tr>
              @if (DataService.SelectedDraw.Players2.length > 3) {
                <tr>
                  <td >4</td>
                  <td>{{DataService.SelectedDraw.Players2[3].name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                    <span>/{{DataService.SelectedDraw.Players2[3].PartnerName}}</span>
                  }</td>
                  @if (RRMatches2?.[4]?.[1]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[4]?.[1].matchNo, 2)" (click)="EnterScore(RRMatches2?.[4]?.[1].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[4]?.[1]?.Score ?? RRMatches2?.[4]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches2?.[4]?.[2]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[4]?.[2].matchNo, 2)" (click)="EnterScore(RRMatches2?.[4]?.[2].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[4]?.[2]?.Score ?? RRMatches2?.[4]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches2?.[4]?.[3]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[4]?.[3].matchNo, 2)" (click)="EnterScore(RRMatches2?.[4]?.[3].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[4]?.[3]?.Score ?? RRMatches2?.[4]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  <td class="Gray"></td>
                  @if (RRMatches2?.[4]?.[5]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[4]?.[5].matchNo, 2)" (click)="EnterScore(RRMatches2?.[4]?.[5].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[4]?.[5]?.Score ?? RRMatches2?.[4]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                </tr>
              }
              @if (DataService.SelectedDraw.Players2.length > 4) {
                <tr>
                  <td >5</td>
                  <td>{{DataService.SelectedDraw.Players2[4].name}}@if (DataService.SelectedDraw.type == 'Doubles') {
                    <span>/{{DataService.SelectedDraw.Players2[4].PartnerName}}</span>
                  }</td>
                  @if (RRMatches2?.[5]?.[1]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[5]?.[1].matchNo, 2)" (click)="EnterScore(RRMatches2?.[5]?.[1].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[5]?.[1]?.Score ?? RRMatches2?.[5]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches2?.[5]?.[2]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[5]?.[2].matchNo, 2)" (click)="EnterScore(RRMatches2?.[5]?.[2].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[5]?.[2]?.Score ?? RRMatches2?.[5]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches2?.[5]?.[3]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[5]?.[3].matchNo, 2)" (click)="EnterScore(RRMatches2?.[5]?.[3].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[5]?.[3]?.Score ?? RRMatches2?.[5]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  @if (RRMatches2?.[5]?.[4]) {
                    <td class="RRmatch" (mouseover)="mouseover(RRMatches2?.[5]?.[4].matchNo, 2)" (click)="EnterScore(RRMatches2?.[5]?.[4].matchNo, 2)" (mouseleave)="mouseLeft()">{{ RRMatches2?.[5]?.[4]?.Score ?? RRMatches2?.[5]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
                  }
                  <td class="Gray"></td>
                </tr>
              }
            </tbody>
          }
        </table>
      }
    </section>
    <section class="panel rr-standings">
      <h3>Standings</h3>
      @if (DataService.SelectedDraw.Matches.length > 0) {
        <table class="rr-standings">
          <thead>
            <tr>
              <th>Pos</th>
              <th>Name</th>
              <th>For</th>
              <th>Against</th>
              <th>Diff</th>
              <th>Wins</th>
            </tr>
          </thead>
          <tbody>
            @for (place of DataService.SelectedDraw.Places1; track place; let i = $index) {
              <tr>
                <td>{{i+1}}</td>
                <td>{{place.name}}</td>
                <td>{{place.for}}</td>
                <td>{{place.against}}</td>
                <td>{{place.diff}}</td>
                <td>{{place.wins}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (DataService.SelectedDraw.Places2?.length > 0) {
        <table class="rr-standings" style="margin-top: 20px">
          <thead>
            <tr>
              <th>Pos</th>
              <th>Name</th>
              <th>For</th>
              <th>Against</th>
              <th>Diff</th>
              <th>Wins</th>
            </tr>
          </thead>
          <tbody>
            @for (place of DataService.SelectedDraw.Places2; track place; let i = $index) {
              <tr>
                <td>{{i+1}}</td>
                <td>{{place.name}}</td>
                <td>{{place.for}}</td>
                <td>{{place.against}}</td>
                <td>{{place.diff}}</td>
                <td>{{place.wins}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (DataService.SelectedMatch != null) {
        <app-score-edit></app-score-edit>
      }
    </section>
    <section class="panel rr-matches">
      <h3>Matches</h3>
      <table class="rr-matches">
        <thead>
          <tr>
            <th>Match</th>
            <th>TT</th>
            <th>Bady</th>
            <th>Squash</th>
            <th>Tennis</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          @for (match of DataService.SelectedDraw.Matches; track match; let i = $index) {
            <tr class="match-row">
              <td>{{match.player1Name}} vs {{match.player2Name}}</td>
              <td>{{match.ttScore1}} - {{match.ttScore2}}</td>
              <td>{{match.badScore1}} - {{match.badScore2}}</td>
              <td>{{match.squashScore1}} - {{match.squashScore2}}</td>
              <td>{{match.tScore1}} - {{match.tScore2}}</td>
              <td>{{match.Score ? match.Score : 'N/A'}} {{match.WOWinner > 0 ? '(W/O)' : ''}}</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  </div>
}
@if (DataService.SelectedDraw.Players1.length + DataService.SelectedDraw.Players2.length > 5 && DataService.SelectedDraw.format === 'RR') {
  <div id="ExtraMatches">
    @if (AllowTornUpdate == true && DataService.LoggedInUser.accessLevel > 1) {
      <div style="margin: 20px">
        <mat-button type="button" id="btnAddExtraMatch" name="btnAddExtraMatch" class="edit-toggle-btn" (click)="addExtraMatch()">Add Match</mat-button>
      </div>
    }
    @for (match of DataService.SelectedDraw.Matches; track match; let i = $index) {
      @if (DataService.SelectedDraw.Players1.length + DataService.SelectedDraw.Players2.length == 6 && match.matchNo > 6 || DataService.SelectedDraw.Players1.length + DataService.SelectedDraw.Players2.length > 6 && match.matchNo > 12) {
        <div class="ExtraMatches ExtraMatchBox" style="display: inline-block; width: 350px">
          @if (AllowTornUpdate == true && DataService.LoggedInUser.accessLevel > 1) {
            <input type="button" id="btnDeleteEM{{i}}" name="btnDeleteEM" (click)="deleteMatch(match.matchNo)" value="X" style="float: right;" />
          }
          <label class="POPlayerLabel PO1">{{match.player1Name}}</label>
          <label class="POPlayerLabel PO2">{{match.player2Name}}</label>
          <label class="POWinnerLabel" (click)="EnterScore(match.matchNo)" (mouseover)="mouseover(match.matchNo, 3)" (mouseleave)="mouseLeft()">{{match.Winner ? match.Winner.name + ' - ' + match.Score : match.dateOfMatch.toLocaleTimeString()}}</label>
        </div>
      }
    }
    @if (DataService.SelectedMatch != null) {
      <app-score-edit class="KOScore"></app-score-edit>
    }
  </div>
}
<!-- <div *ngIf="DataService.SelectedDraw.format === 'RRR'" class="TheRRDrawContainer Draw-Layout" id="RR1">
<div class="TheDraw">
  <table class="table-layout" *ngIf="isRRReady">
    <thead id="THead">
      <tr>
        <th><button *ngIf="DataService.SelectedDraw.Matches.length === 0 && DataService.SelectedDraw.Players1.length > 2 && AllowTornUpdate == true" type="button" name="btnCreateMatchesForRR1" id="btnCreateMatchesForRR1" (click)="createMatchesForRR(DataService.SelectedDraw)">Create Matches</button></th>
        <th class="drawTitle">{{DataService.SelectedDraw.name}}</th>
        <th>1</th>
        <th>2</th>
        <th>3</th>
        <th *ngIf="DataService.SelectedDraw.Players1.length > 3">4</th>
        <th *ngIf="DataService.SelectedDraw.Players1.length > 4">5</th>
        <th *ngIf="DataService.SelectedDraw.Players1.length > 5">6</th>
      </tr>
    </thead>
    <tbody id="TableBody1" #TableBody1 *ngIf="RRMatches">
      <tr>
        <td>1</td>
        <td>{{DataService.SelectedDraw.Players1[0].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players1[0].PartnerName}}</span></td>
        <td class="Gray"></td>
        <td *ngIf="RRMatches?.[1]?.[2]" (mouseover)="mouseover(RRMatches?.[1]?.[2].matchNo - 1)" (click)="EnterScore(RRMatches?.[1]?.[2].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[1]?.[2].matchNo - 1)">{{ RRMatches?.[1]?.[2]?.Score ?? RRMatches?.[1]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[1]?.[3]" (mouseover)="mouseover(RRMatches?.[1]?.[3].matchNo - 1)" (click)="EnterScore(RRMatches?.[1]?.[3].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[1]?.[3].matchNo - 1)">{{ RRMatches?.[1]?.[3]?.Score ?? RRMatches?.[1]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[1]?.[4]" (mouseover)="mouseover(RRMatches?.[1]?.[4].matchNo - 1)" (click)="EnterScore(RRMatches?.[1]?.[4].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[1]?.[4].matchNo - 1)">{{ RRMatches?.[1]?.[4]?.Score ?? RRMatches?.[1]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[1]?.[5]" (mouseover)="mouseover(RRMatches?.[1]?.[5].matchNo - 1)" (click)="EnterScore(RRMatches?.[1]?.[5].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[1]?.[5].matchNo - 1)">{{ RRMatches?.[1]?.[5]?.Score ?? RRMatches?.[1]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[1]?.[6]" (mouseover)="mouseover(RRMatches?.[1]?.[6].matchNo - 1)" (click)="EnterScore(RRMatches?.[1]?.[6].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[1]?.[6].matchNo - 1)">{{ RRMatches?.[1]?.[6]?.Score ?? RRMatches?.[1]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
      </tr>
      <tr>
        <td>2</td>
        <td>{{DataService.SelectedDraw.Players1[1].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players1[1].PartnerName}}</span></td>
        <td *ngIf="RRMatches?.[2]?.[1]" (mouseover)="mouseover(RRMatches?.[2]?.[1].matchNo - 1)" (click)="EnterScore(RRMatches?.[2]?.[1].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[2]?.[1].matchNo - 1)">{{ RRMatches?.[2]?.[1]?.Score ?? RRMatches?.[2]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td class="Gray"></td>
        <td *ngIf="RRMatches?.[2]?.[3]" (mouseover)="mouseover(RRMatches?.[2]?.[3].matchNo - 1)" (click)="EnterScore(RRMatches?.[2]?.[3].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[2]?.[3].matchNo - 1)">{{ RRMatches?.[2]?.[3]?.Score ?? RRMatches?.[2]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[2]?.[4]" (mouseover)="mouseover(RRMatches?.[2]?.[4].matchNo - 1)" (click)="EnterScore(RRMatches?.[2]?.[4].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[2]?.[4].matchNo - 1)">{{ RRMatches?.[2]?.[4]?.Score ?? RRMatches?.[2]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[2]?.[5]" (mouseover)="mouseover(RRMatches?.[2]?.[5].matchNo - 1)" (click)="EnterScore(RRMatches?.[2]?.[5].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[2]?.[5].matchNo - 1)">{{ RRMatches?.[2]?.[5]?.Score ?? RRMatches?.[2]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[2]?.[6]" (mouseover)="mouseover(RRMatches?.[2]?.[6].matchNo - 1)" (click)="EnterScore(RRMatches?.[2]?.[6].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[2]?.[6].matchNo - 1)">{{ RRMatches?.[2]?.[6]?.Score ?? RRMatches?.[2]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
      </tr>
      <tr>
        <td>3</td>
        <td>{{DataService.SelectedDraw.Players1[2].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players1[2].PartnerName}}</span></td>
        <td *ngIf="RRMatches?.[3]?.[1]" (mouseover)="mouseover(RRMatches?.[3]?.[1].matchNo - 1)" (click)="EnterScore(RRMatches?.[3]?.[1].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[3]?.[1].matchNo - 1)">{{ RRMatches?.[3]?.[1]?.Score ?? RRMatches?.[3]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[3]?.[2]" (mouseover)="mouseover(RRMatches?.[3]?.[2].matchNo - 1)" (click)="EnterScore(RRMatches?.[3]?.[2].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[3]?.[2].matchNo - 1)">{{ RRMatches?.[3]?.[2]?.Score ?? RRMatches?.[3]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td class="Gray"></td>
        <td *ngIf="RRMatches?.[3]?.[4]" (mouseover)="mouseover(RRMatches?.[3]?.[4].matchNo - 1)" (click)="EnterScore(RRMatches?.[3]?.[4].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[3]?.[4].matchNo - 1)">{{ RRMatches?.[3]?.[4]?.Score ?? RRMatches?.[3]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[3]?.[5]" (mouseover)="mouseover(RRMatches?.[3]?.[5].matchNo - 1)" (click)="EnterScore(RRMatches?.[3]?.[5].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[3]?.[5].matchNo - 1)">{{ RRMatches?.[3]?.[5]?.Score ?? RRMatches?.[3]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[3]?.[6]" (mouseover)="mouseover(RRMatches?.[3]?.[6].matchNo - 1)" (click)="EnterScore(RRMatches?.[3]?.[6].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[3]?.[6].matchNo - 1)">{{ RRMatches?.[3]?.[6]?.Score ?? RRMatches?.[3]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
      </tr>
      <tr *ngIf="DataService.SelectedDraw.Players1.length > 3">
        <td >4</td>
        <td>{{DataService.SelectedDraw.Players1[3].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players1[3].PartnerName}}</span></td>
        <td *ngIf="RRMatches?.[4]?.[1]" (mouseover)="mouseover(RRMatches?.[4]?.[1].matchNo - 1)" (click)="EnterScore(RRMatches?.[4]?.[1].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[4]?.[1].matchNo - 1)">{{ RRMatches?.[4]?.[1]?.Score ?? RRMatches?.[4]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[4]?.[2]" (mouseover)="mouseover(RRMatches?.[4]?.[2].matchNo - 1)" (click)="EnterScore(RRMatches?.[4]?.[2].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[4]?.[2].matchNo - 1)">{{ RRMatches?.[4]?.[2]?.Score ?? RRMatches?.[4]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[4]?.[3]" (mouseover)="mouseover(RRMatches?.[4]?.[3].matchNo - 1)" (click)="EnterScore(RRMatches?.[4]?.[3].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[4]?.[3].matchNo - 1)">{{ RRMatches?.[4]?.[3]?.Score ?? RRMatches?.[4]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td class="Gray"></td>
        <td *ngIf="RRMatches?.[4]?.[5]" (mouseover)="mouseover(RRMatches?.[4]?.[5].matchNo - 1)" (click)="EnterScore(RRMatches?.[4]?.[5].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[4]?.[5].matchNo - 1)">{{ RRMatches?.[4]?.[5]?.Score ?? RRMatches?.[4]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[4]?.[6]" (mouseover)="mouseover(RRMatches?.[4]?.[6].matchNo - 1)" (click)="EnterScore(RRMatches?.[4]?.[6].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[4]?.[6].matchNo - 1)">{{ RRMatches?.[4]?.[6]?.Score ?? RRMatches?.[4]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
      </tr>
      <tr *ngIf="DataService.SelectedDraw.Players1.length > 4">
        <td >5</td>
        <td >{{DataService.SelectedDraw.Players1[4].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players1[4].PartnerName}}</span></td>
        <td *ngIf="RRMatches?.[5]?.[1]" (mouseover)="mouseover(RRMatches?.[5]?.[1].matchNo - 1)" (click)="EnterScore(RRMatches?.[5]?.[1].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[5]?.[1].matchNo - 1)">{{ RRMatches?.[5]?.[1]?.Score ?? RRMatches?.[5]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[5]?.[2]" (mouseover)="mouseover(RRMatches?.[5]?.[2].matchNo - 1)" (click)="EnterScore(RRMatches?.[5]?.[2].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[5]?.[2].matchNo - 1)">{{ RRMatches?.[5]?.[2]?.Score ?? RRMatches?.[5]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[5]?.[3]" (mouseover)="mouseover(RRMatches?.[5]?.[3].matchNo - 1)" (click)="EnterScore(RRMatches?.[5]?.[3].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[5]?.[3].matchNo - 1)">{{ RRMatches?.[5]?.[3]?.Score ?? RRMatches?.[5]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[5]?.[4]" (mouseover)="mouseover(RRMatches?.[5]?.[4].matchNo - 1)" (click)="EnterScore(RRMatches?.[5]?.[4].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[5]?.[4].matchNo - 1)">{{ RRMatches?.[5]?.[4]?.Score ?? RRMatches?.[5]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td class="Gray"></td>
        <td *ngIf="DataService.SelectedDraw.Players1.length > 4 && RRMatches?.[5]?.[6]" (mouseover)="mouseover(RRMatches?.[5]?.[6].matchNo - 1)" (click)="EnterScore(RRMatches?.[5]?.[6].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[5]?.[6].matchNo - 1)">{{ RRMatches?.[5]?.[6]?.Score ?? RRMatches?.[5]?.[6]?.dateOfMatch.toLocaleTimeString()}}</td>
      </tr>
      <tr *ngIf="DataService.SelectedDraw.Players1.length > 5">
        <td >6</td>
        <td>{{DataService.SelectedDraw.Players1[5].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players1[5].PartnerName}}</span></td>
        <td *ngIf="RRMatches?.[6]?.[1]" (mouseover)="mouseover(RRMatches?.[6]?.[1].matchNo - 1)" (click)="EnterScore(RRMatches?.[6]?.[1].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[6]?.[1].matchNo - 1)">{{ RRMatches?.[6]?.[1]?.Score ?? RRMatches?.[6]?.[1]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[6]?.[2]" (mouseover)="mouseover(RRMatches?.[6]?.[2].matchNo - 1)" (click)="EnterScore(RRMatches?.[6]?.[2].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[6]?.[2].matchNo - 1)">{{ RRMatches?.[6]?.[2]?.Score ?? RRMatches?.[6]?.[2]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[6]?.[3]" (mouseover)="mouseover(RRMatches?.[6]?.[3].matchNo - 1)" (click)="EnterScore(RRMatches?.[6]?.[3].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[6]?.[3].matchNo - 1)">{{ RRMatches?.[6]?.[3]?.Score ?? RRMatches?.[6]?.[3]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[6]?.[4]" (mouseover)="mouseover(RRMatches?.[6]?.[4].matchNo - 1)" (click)="EnterScore(RRMatches?.[6]?.[4].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[6]?.[4].matchNo - 1)">{{ RRMatches?.[6]?.[4]?.Score ?? RRMatches?.[6]?.[4]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td *ngIf="RRMatches?.[6]?.[5]" (mouseover)="mouseover(RRMatches?.[6]?.[5].matchNo - 1)" (click)="EnterScore(RRMatches?.[6]?.[5].matchNo - 1)" (mouseleave)="mouseLeft(RRMatches?.[6]?.[5].matchNo - 1)">{{ RRMatches?.[6]?.[5]?.Score ?? RRMatches?.[6]?.[5]?.dateOfMatch.toLocaleTimeString()}}</td>
        <td class="Gray"></td>
      </tr>
    </tbody>
  </table>
  <h2>Standings:</h2>
  <table *ngIf="DataService.SelectedDraw.Matches.length > 0" class="table-layout">
    <thead>
      <tr>
        <th>Pos</th>
        <th>Name</th>
        <th>For</th>
        <th>Against</th>
        <th>Diff</th>
        <th>Wins</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let place of DataService.SelectedDraw.Places1; let i = index">
        <td>{{i+1}}</td>
        <td>{{place.name}}</td>
        <td>{{place.for}}</td>
        <td>{{place.against}}</td>
        <td>{{place.diff}}</td>
        <td>{{place.wins}}</td>
      </tr>
    </tbody>
  </table>
  <hr>
    <table *ngIf="DataService.SelectedDraw.Places2.length > 0" class="table-layout">
      <thead>
        <tr>
          <th>Pos</th>
          <th>Name</th>
          <th>For</th>
          <th>Against</th>
          <th>Diff</th>
          <th>Wins</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let place of DataService.SelectedDraw.Places2; let i = index">
          <td>{{i+1}}</td>
          <td>{{place.name}}</td>
          <td>{{place.for}}</td>
          <td>{{place.against}}</td>
          <td>{{place.diff}}</td>
          <td>{{place.wins}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <hr>
    <div class="TheDraw" *ngIf="DataService.SelectedDraw.Players2 && DataService.SelectedDraw.Players2.length > 0">
      <table class="table-layout" *ngIf="isRRReady" style="margin-top: 20px;">
        <thead id="THead">
          <tr>
            <th></th>
            <th class="drawTitle">{{DataService.SelectedDraw.name}}</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
          </tr>
        </thead>
        <tbody id="TableBody1" #TableBody1 *ngIf="RRMatches2">
          <tr>
            <td>1</td>
            <td>{{DataService.SelectedDraw.Players2[0].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players2[0].PartnerName}}</span></td>
            <td class="Gray"></td>
            <td *ngIf="RRMatches2?.[1]?.[2]" (hover)="HoveredMatch = RRMatches2?.[1]?.[2]">{{ RRMatches2?.[1]?.[2]?.Score ?? RRMatches2?.[1]?.[2]?.dateOfMatch}}</td>
            <td *ngIf="RRMatches2?.[1]?.[3]">{{ RRMatches2?.[1]?.[3]?.Score ?? RRMatches2?.[1]?.[3]?.dateOfMatch}}</td>
          </tr>
          <tr>
            <td>2</td>
            <td>{{DataService.SelectedDraw.Players2[1].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players2[1].PartnerName}}</span></td>
            <td *ngIf="RRMatches2?.[2]?.[1]">{{ RRMatches2?.[2]?.[1]?.Score ?? RRMatches2?.[2]?.[1]?.dateOfMatch}}</td>
            <td class="Gray"></td>
            <td *ngIf="RRMatches2?.[2]?.[3]">{{ RRMatches2?.[2]?.[3]?.Score ?? RRMatches2?.[2]?.[3]?.dateOfMatch}}</td>
          </tr>
          <tr>
            <td>3</td>
            <td>{{DataService.SelectedDraw.Players2[2].name}}<span *ngIf="DataService.SelectedDraw.type == 'Doubles'">/{{DataService.SelectedDraw.Players2[2].PartnerName}}</span></td>
            <td *ngIf="RRMatches2?.[3]?.[1]">{{ RRMatches2?.[3]?.[1]?.Score ?? RRMatches2?.[3]?.[1]?.dateOfMatch}}</td>
            <td *ngIf="RRMatches2?.[3]?.[2]">{{ RRMatches2?.[3]?.[2]?.Score ?? RRMatches2?.[3]?.[2]?.dateOfMatch}}</td>
            <td class="Gray"></td>
          </tr>
        </tbody>
      </table>
      <h2>Standings:</h2>
      <table *ngIf="DataService.SelectedDraw.Matches.length > 0" class="table-layout">
        <thead>
          <tr>
            <th>Pos</th>
            <th>Name</th>
            <th>For</th>
            <th>Against</th>
            <th>Diff</th>
            <th>Wins</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let place of DataService.SelectedDraw.Places2; let i = index">
            <td>{{i+1}}</td>
            <td>{{place.name}}</td>
            <td>{{place.for}}</td>
            <td>{{place.against}}</td>
            <td>{{place.diff}}</td>
            <td>{{place.wins}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="TheMatches">
      <h2>Matches:</h2>
      <table class="table-layout">
        <thead>
          <tr>
            <th>Match</th>
            <th>TT</th>
            <th>Bady</th>
            <th>Squash</th>
            <th>Tennis</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let match of DataService.SelectedDraw.Matches; let i = index">
            <td>{{match.player1Name}} vs {{match.player2Name}}</td>
            <td>{{match.ttScore1}} - {{match.ttScore2}}</td>
            <td>{{match.badScore1}} - {{match.badScore2}}</td>
            <td>{{match.squashScore1}} - {{match.squashScore2}}</td>
            <td>{{match.tScore1}} - {{match.tScore2}}</td>
            <td>{{match.Score ? match.Score : 'N/A'}} {{match.WOWinner > 0 ? '(W/O)' : ''}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <button type="button" *ngIf="AllowTornUpdate == true" class="DeleteDraw" id="btnDeleteDrawRR1" name="btnDeleteDraw" (click)="DeleteCurrentDraw()">Delete Draw</button>
    <mat-button type="button" (click)="DeleteMatches()" *ngIf="AllowTornUpdate == true" class="DeleteDraw" id="btnDeleteMatchesRR1" name="btnDeleteMatchesRR1">Delete All Matches</mat-button>
    <app-score-edit [isEditingMatchScore]="isEditingMatchScore" *ngIf="DataService.SelectedMatch != null"></app-score-edit>
  </div> -->
</div>
}
<!-- <div *ngIf="DataService.SelectedDraw && DataService.SelectedDraw.Matches && DataService.SelectedDraw.Players1 && DataService.SelectedDraw.format === 'RR'" class="TheRRDrawContainer" id="RR1">
<div class="HiddenHeading" >{{DataService.SelectedDraw.name}}</div>
<table class="table-layout">
  <thead id="THead">
    <tr>
      <th><button *ngIf="DataService.SelectedDraw.Matches.length === 0 && DataService.SelectedDraw.Players1.length > 2 && AllowTornUpdate == true" type="button" name="btnCreateMatchesForRR1" id="btnCreateMatchesForRR1" (click)="createMatchesForRR(DataService.SelectedDraw)">Create Matches</button></th>
      <th></th>
      <th>1</th>
      <th>2</th>
      <th>3</th>
      <th *ngIf="DataService.TableRows1 > 3">4</th>
      <th *ngIf="DataService.TableRows1 > 4">5</th>
      <th *ngIf="DataService.TableRows1 > 5">6</th>
    </tr>
  </thead>
  <tbody id="TableBody1" #TableBody1>
    <tr>
      <td class="Links">
        1
        <ul *ngIf="DataService.SelectedDraw.Players1.length === 0 && DataService.SelectedDraw.Matches.length == 0">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index"><button type="button" id="ThePlayers11{{i}}" (click)="addPlayerToRR(1,1,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles' ? player.name : player.name + '/' + player.PartnerName}}</button></li>

        </ul>
      </td>
      <td (click)="removePlayerFromDraw(1)"></td>
      <td class="Gray"></td>
      <td id="R1RScore1" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore2" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" name="RRScore2" class="result"></td>
      <td id="R1RScore3" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 3" class="result"></td>
      <td id="R1RScore4" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 4" class="result"></td>
      <td id="R1RScore5" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 5" class="result"></td>
    </tr>
    <tr>
      <td class="Links">
        2
        <ul *ngIf="DataService.SelectedDraw.Players1.length === 1 && DataService.SelectedDraw.Matches.length == 0">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index"><button type="button" id="ThePlayers12{{i}}" (click)="addPlayerToRR(1,2,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button></li>

        </ul>
      </td>
      <td></td>
      <td id="R1RScore6" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td class="Gray"></td>
      <td id="R1RScore7" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore8" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 3" class="result"></td>
      <td id="R1RScore9" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 4" class="result"></td>
      <td id="R1RScore10" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 5" class="result"></td>
    </tr>
    <tr>
      <td class="Links">
        3
        <ul *ngIf="DataService.SelectedDraw.Players1.length === 2 && DataService.SelectedDraw.Matches.length == 0">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers13{{i}}" (click)="addPlayerToRR(1,3,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R1RScore11" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore12" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td class="Gray"></td>
      <td id="R1RScore13" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 3" class="result"></td>
      <td id="R1RScore14" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 4" class="result"></td>
      <td id="R1RScore15" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 5" class="result"></td>
    </tr>
    <tr *ngIf="DataService.TableRows1 > 3">
      <td class="Links">
        4
        <ul *ngIf="DataService.SelectedDraw.Players1.length === 3 && DataService.SelectedDraw.Matches.length == 0">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers14{{i}}" (click)="addPlayerToRR(1,4,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R1RScore16" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore17" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore18" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td class="Gray"></td>
      <td id="R1RScore19" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 4" class="result"></td>
      <td id="R1RScore20" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 5" class="result"></td>
    </tr>
    <tr *ngIf="DataService.TableRows1 > 4">
      <td class="Links">
        5
        <ul *ngIf="DataService.SelectedDraw.Players1.length === 4 && DataService.SelectedDraw.Matches.length == 0">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers15{{i}}" (click)="addPlayerToRR(1,5,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R1RScore21" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" type="button" class="result"></td>
      <td id="R1RScore22" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore23" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore24" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td class="Gray"></td>
      <td id="R1RScore25" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" *ngIf="DataService.TableRows1 > 5" class="result"></td>
    </tr>
    <tr *ngIf="DataService.TableRows1 > 5">
      <td class="Links">
        6
        <ul *ngIf="DataService.SelectedDraw.Players1.length === 5 && DataService.SelectedDraw.Matches.length == 0">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers16{{i}}" (click)="addPlayerToRR(1,6,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R1RScore26" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);"  type="button" class="result"></td>
      <td id="R1RScore27" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore28" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore29" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td id="R1RScore30" (click)="enterRRScore($event)" (mouseover)="RRmouseover($event,1);" (mouseleave)="RRshowScoreHover1 = false" type="button" class="result"></td>
      <td class="Gray"></td>
    </tr>
  </tbody>
</table>
<div *ngIf="DataService.SelectedDraw.Matches.length === 0 && AllowTornUpdate == true">
  <button type="button" id="btnExtraPlayer1" name="btnExtraPlayer" (click)="addPositionToRRDraw(1)">+</button>
  <button type="button" id="btnLessPlayer1" name="btnLessPlayer" (click)="removePositionToRRDraw(1)">-</button>
  <button type="button" id="btnclearDraw1" name="btnclearDraw" (click)="clearPlayersFromDraw(1)">Reset Draw</button>
</div>
<div *ngIf="AllowTornUpdate == true">
  <input *ngIf="DataService.SelectedDraw.NumberOfRRs == 1" type="button" id="AddRR" name="AddRR" value="Add RR" (click)="AddRR()" />
  <button type="button" *ngIf="AllowTornUpdate == true" class="DeleteDraw" id="btnDeleteDrawRR1" name="btnDeleteDraw" (click)="DeleteCurrentDraw()">Delete Draw</button>
</div>
<hr />
<div id="RRScoreHover" *ngIf="RRshowScoreHover1 == true">
  <label class="names">{{HoveredMatch.player1Name}}  </label><label>{{HoveredMatch.ttScore1}}</label><label>{{HoveredMatch.badScore1}}</label><label>{{HoveredMatch.squashScore1}}</label><label>{{HoveredMatch.tScore1}}</label><br />
  <label class="names">{{HoveredMatch.player2Name}}  </label><label>{{HoveredMatch.ttScore2}}</label><label>{{HoveredMatch.badScore2}}</label><label>{{HoveredMatch.squashScore2}}</label><label>{{HoveredMatch.tScore2}}</label>
</div>

<h2>Standings:</h2>
<table *ngIf="DataService.SelectedDraw.Matches.length > 0" class="table-layout">
  <thead>
    <tr>
      <th>Pos</th>
      <th>Name</th>
      <th>For</th>
      <th>Against</th>
      <th>Diff</th>
      <th>Wins</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let place of DataService.SelectedDraw.Places1; let i = index">
      <td>{{i+1}}</td>
      <td>{{place.name}}</td>
      <td>{{place.for}}</td>
      <td>{{place.against}}</td>
      <td>{{place.diff}}</td>
      <td>{{place.wins}}</td>
    </tr>
  </tbody>
</table>
</div> -->

<!-- <div *ngIf="DataService.SelectedDraw && DataService.SelectedDraw.format === 'RR' && DataService.SelectedDraw.numberOfRRs > 1 && DataService.SelectedDraw.Players2" class="TheRRDrawContainer" id="RR2">
<div class="HiddenHeading" style="display: none">{{DataService.SelectedDraw.name}}</div>
<table class="table-layout">
  <thead id="THead">
    <tr>
      <th><button *ngIf="DataService.SelectedDraw.Matches.length === 0 && DataService.SelectedDraw.Players2.length > 2 && AllowTornUpdate == true" type="button" name="btnCreateMatchesForRR" id="btnCreateMatchesForRR" (click)="createMatchesForRR(DataService.SelectedDraw)">Create Matches</button></th>
      <th></th>
      <th>1</th>
      <th>2</th>
      <th>3</th>
      <th *ngIf="DataService.TableRows2 > 3">4</th>
      <th *ngIf="DataService.TableRows2 > 4">5</th>
      <th *ngIf="DataService.TableRows2 > 5">6</th>
    </tr>
  </thead>
  <tbody id="TableBody2">
    <tr>
      <td class="Links">
        1
        <ul *ngIf="DataService.SelectedDraw.Matches.length == 0 && DataService.SelectedDraw.Players2.length === 0">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers"><button type="button" id="ThePlayers21{{i}}" (click)="addPlayerToRR(2,1,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button></li>

        </ul>
      </td>
      <td></td>
      <td class="Gray"></td>
      <td id="R2RScore1" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore2" (click)="enterRRScore($event)" name="RRScore2" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore3" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 3" class="result"></td>
      <td id="R2RScore4" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 4" class="result"></td>
      <td id="R2RScore5" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 5" class="result"></td>
    </tr>
    <tr>
      <td class="Links">
        2
        <ul *ngIf="DataService.SelectedDraw.Matches.length == 0 && DataService.SelectedDraw.Players2.length === 1">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index"><button type="button" id="ThePlayers22{{i}}" (click)="addPlayerToRR(2,2,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button></li>

        </ul>
      </td>
      <td></td>
      <td id="R2RScore6" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td class="Gray"></td>
      <td id="R2RScore7" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore8" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 3" class="result"></td>
      <td id="R2RScore9" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 4" class="result"></td>
      <td id="R2RScore10" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 5" class="result"></td>
    </tr>
    <tr>
      <td class="Links">
        3
        <ul *ngIf="DataService.SelectedDraw.Matches.length == 0 && DataService.SelectedDraw.Players2.length === 2">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers23{{i}}" (click)="addPlayerToRR(2,3,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R2RScore11" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore12" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td class="Gray"></td>
      <td id="R2RScore13" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 3" class="result"></td>
      <td id="R2RScore14" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 4" class="result"></td>
      <td id="R2RScore15" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 5" class="result"></td>
    </tr>
    <tr *ngIf="DataService.TableRows2 > 3">
      <td class="Links">
        4
        <ul *ngIf="DataService.SelectedDraw.Matches.length == 0 && DataService.SelectedDraw.Players2.length === 3">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers24{{i}}" (click)="addPlayerToRR(2,4,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R2RScore16" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore17" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore18" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td class="Gray"></td>
      <td id="R2RScore19" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 4" class="result"></td>
      <td id="R2RScore20" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 5" class="result"></td>
    </tr>
    <tr *ngIf="DataService.TableRows2 > 4">
      <td class="Links">
        5
        <ul *ngIf="DataService.SelectedDraw.Matches.length == 0 && DataService.SelectedDraw.Players2.length === 4">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers25{{i}}" (click)="addPlayerToRR(2,5,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R2RScore21" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore22" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore23" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore24" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td class="Gray"></td>
      <td id="R2RScore25" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" *ngIf="DataService.TableRows2 > 5" class="result"></td>
    </tr>
    <tr *ngIf="DataService.TableRows2 > 5">
      <td class="Links">
        6
        <ul *ngIf="DataService.SelectedDraw.Matches.length == 0 && DataService.SelectedDraw.Players2.length === 5">

          <li class="Links-content" *ngFor="let player of DataService.SelectedDraw.AvailablePlayers; let i = index">
            <button type="button" id="ThePlayers26{{i}}" (click)="addPlayerToRR(2,6,i)">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</button>
          </li>

        </ul>
      </td>
      <td></td>
      <td id="R2RScore26" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore27" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore28" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore29" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td id="R2RScore30" (click)="enterRRScore($event)" type="button" (mouseover)="RRmouseover($event,2);" (mouseleave)="RRshowScoreHover2 = false" class="result"></td>
      <td class="Gray"></td>
    </tr>
  </tbody>
</table>

<div *ngIf="DataService.SelectedDraw.Matches.length === 0 && AllowTornUpdate == true">
  <button type="button" id="btnExtraPlayer" name="btnExtraPlayer" (click)="addPositionToRRDraw(2)">+</button>
  <button type="button" id="btnLessPlayer" name="btnLessPlayer" (click)="removePositionToRRDraw(2)">-</button>
  <button type="button" id="btnclearDraw" name="btnclearDraw" (click)="clearPlayersFromDraw(2)">Reset Draw</button>
  <button type="button" id="btnDeleteRR" name="btnDeleteRR" (click)="DataService.SelectedDraw.NumberOfRRs = 1">Delete 2nd Round Robin</button>
</div>
<hr />
<div id="RRScoreHover" *ngIf="RRshowScoreHover2 == true">
  <label class="names">{{HoveredMatch.player1Name}}  </label><label>{{HoveredMatch.ttScore1}}</label><label>{{HoveredMatch.badScore1}}</label><label>{{HoveredMatch.squashScore1}}</label><label>{{HoveredMatch.tScore1}}</label><br />
  <label class="names">{{HoveredMatch.player2Name}}  </label><label>{{HoveredMatch.ttScore2}}</label><label>{{HoveredMatch.badScore2}}</label><label>{{HoveredMatch.squashScore2}}</label><label>{{HoveredMatch.tScore2}}</label>
</div>
<h2>Standings:</h2>
<table *ngIf="DataService.SelectedDraw.Matches.length > 0" class="table-layout">
  <thead>
    <tr>
      <td>Pos</td>
      <td>Name</td>
      <td>For</td>
      <td>Against</td>
      <td>Diff</td>
      <td>Wins</td>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let place of DataService.SelectedDraw.Places2; let i = index">
      <td>{{i+1}}</td>
      <td>{{place.name}}</td>
      <td>{{place.for}}</td>
      <td>{{place.against}}</td>
      <td>{{place.diff}}</td>
      <td>{{place.wins}}</td>
    </tr>
  </tbody>
</table>
<input type="button" id="AddPOs" *ngIf="AllowTornUpdate == true && DataService.SelectedDraw.Matches.length >= NormalLimit && DataService.SelectedDraw.Matches.length > 0" name="AddPOs" value="Add Play Off Matches" (click)="addPlayOffMatchesToDraw()" />
</div> -->

@if (DataService.SelectedDraw?.format === 'RR') {
  <div id="POMatches">
    <!--<input type="button" id="btnAddExtraMatch" name="btnAddExtraMatch" (click)="addExtraMatch()" value="Add Match" />-->
    @if (DataService.SelectedDraw.Matches.length > NormalLimit) {
      <div class="POMatches ExtraMatchBox" id="POMatch1">
        @if (AllowTornUpdate == true) {
          <button type="button" id="btnDeletePO1" name="btnDeletePO" (click)="deletePO(1)" style="float: right;" >X</button>
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(1,1)">{{DataService.SelectedDraw.Matches[NormalLimit].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit].player1) {
            <select id="POSelector11" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit].player1" [ngChange]="updatePOLabel(1,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(1,2)">{{DataService.SelectedDraw.Matches[NormalLimit].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit].player2) {
            <select id="POSelector12" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit].player2" [ngChange]="updatePOLabel(1,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW1" class="POWinnerLabel" (click)="enterPOScore(1)" name="{{NormalLimit}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit].Winner}}</label>
        <label id="RRPOS1" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit].Score}}</label>
      </div>
    }
    @if (DataService.SelectedDraw.Matches.length > (NormalLimit + 1)) {
      <div class="POMatches ExtraMatchBox" id="POMatch2">
        @if (AllowTornUpdate == true) {
          <input type="button" id="btnDeletePO2" name="btnDeletePO" (click)="deletePO(2)" value="X" style="float: right;" />
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(2,1)">{{DataService.SelectedDraw.Matches[NormalLimit+1].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+1].player1) {
            <select id="POSelector21" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+1].player1" [ngChange]="updatePOLabel(2,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(2,2)">
          {{DataService.SelectedDraw.Matches[NormalLimit+1].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+1].player2) {
            <select id="POSelector22" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+1].player2" [ngChange]="updatePOLabel(2,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW2" class="POWinnerLabel" (click)="enterPOScore(2)" name="{{NormalLimit+1}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit+1].Winner}}</label>
        <label id="RRPOS2" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit+1].Score}}</label>
      </div>
    }
    @if (DataService.SelectedDraw.Matches.length > (NormalLimit + 2)) {
      <div class="POMatches ExtraMatchBox" id="POMatch3">
        @if (AllowTornUpdate == true) {
          <input type="button" id="btnDeletePO3" name="btnDeletePO" (click)="deletePO(3)" value="X" style="float: right;" />
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(3,1)">
          {{DataService.SelectedDraw.Matches[NormalLimit+2].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+2].player1) {
            <select id="POSelector31" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+2].player1" [ngChange]="updatePOLabel(3,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(3,2)">
          {{DataService.SelectedDraw.Matches[NormalLimit+2].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+2].player2) {
            <select id="POSelector32" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+2].player2" [ngChange]="updatePOLabel(3,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW3" class="POWinnerLabel" (click)="enterPOScore(3)" name="{{NormalLimit+2}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit+2].Winner}}</label>
        <label id="RRPOS3" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit+2].Score}}</label>
      </div>
    }
    @if (DataService.SelectedDraw.Matches.length > (NormalLimit + 3)) {
      <div class="POMatches ExtraMatchBox" id="POMatch4">
        @if (AllowTornUpdate == true) {
          <input type="button" id="btnDeletePO4" name="btnDeletePO" (click)="deletePO(4)" value="X" style="float: right;" />
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(4,1)">
          {{DataService.SelectedDraw.Matches[NormalLimit+3].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+3].player1) {
            <select id="POSelector41" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+3].player1" [ngChange]="updatePOLabel(4,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(4,2)">
          {{DataService.SelectedDraw.Matches[NormalLimit+3].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+3].player2) {
            <select id="POSelector42" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+3].player2" [ngChange]="updatePOLabel(4,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW4" class="POWinnerLabel" (click)="enterPOScore(4)" name="{{NormalLimit+3}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit+3].Winner}}</label>
        <label id="RRPOS4" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit+3].Score}}</label>
      </div>
    }
    @if (DataService.SelectedDraw.Matches.length > (NormalLimit + 4)) {
      <div class="POMatches ExtraMatchBox" id="POMatch5">
        @if (AllowTornUpdate == true) {
          <input type="button" id="btnDeletePO5" name="btnDeletePO" (click)="deletePO(5)" value="X" style="float: right;" />
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(5,1)">
          {{DataService.SelectedDraw.Matches[NormalLimit+4].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+4].player1) {
            <select id="POSelector51" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+4].player1" [ngChange]="updatePOLabel(5,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(5,2)">
          {{DataService.SelectedDraw.Matches[NormalLimit+4].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+4].player2) {
            <select id="POSelector52" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+4].player2" [ngChange]="updatePOLabel(5,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW5" class="POWinnerLabel" (click)="enterPOScore(5)" name="{{NormalLimit+4}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit+4].Winner}}</label>
        <label id="RRPOS5" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit+4].Score}}</label>
      </div>
    }
    @if (DataService.SelectedDraw.Matches.length > (NormalLimit + 5)) {
      <div class="POMatches ExtraMatchBox" id="POMatch6">
        @if (AllowTornUpdate == true) {
          <input type="button" id="btnDeletePO6" name="btnDeletePO" (click)="deletePO(6)" value="X" style="float: right;" />
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(6,1)">
          {{DataService.SelectedDraw.Matches[NormalLimit+5].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+5].player1) {
            <select id="POSelector61" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+5].player1" [ngChange]="updatePOLabel(6,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(6,2)">
          {{DataService.SelectedDraw.Matches[NormalLimit+5].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+5].player2) {
            <select id="POSelector62" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+5].player2" [ngChange]="updatePOLabel(6,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW6" class="POWinnerLabel" (click)="enterPOScore(6)" name="{{NormalLimit+5}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit+5].Winner}}</label>
        <label id="RRPOS6" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit+5].Score}}</label>
      </div>
    }
    @if (DataService.SelectedDraw.Matches.length > (NormalLimit + 6)) {
      <div class="POMatches ExtraMatchBox" id="POMatch7">
        @if (AllowTornUpdate == true) {
          <input type="button" id="btnDeletePO7" name="btnDeletePO" (click)="deletePO(7)" value="X" style="float: right;" />
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(7,1)">
          {{DataService.SelectedDraw.Matches[NormalLimit+5].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+6].player1) {
            <select id="POSelector71" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+6].player1" [ngChange]="updatePOLabel(7,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(7,2)">
          {{DataService.SelectedDraw.Matches[NormalLimit+5].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+6].player2) {
            <select id="POSelector72" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+6].player2" [ngChange]="updatePOLabel(7,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW7" class="POWinnerLabel" (click)="enterPOScore(7)" name="{{NormalLimit+6}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit+6].Winner}}</label>
        <label id="RRPOS7" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit+6].Score}}</label>
      </div>
    }
    @if (DataService.SelectedDraw.Matches.length > (NormalLimit + 7)) {
      <div class="POMatches ExtraMatchBox" id="POMatch8">
        @if (AllowTornUpdate == true) {
          <input type="button" id="btnDeletePO8" name="btnDeletePO" (click)="deletePO(8)" value="X" style="float: right;" />
        }
        <label id="RRPOP1" class="POPlayerLabel PO1" (click)="clearPOLabel(8,1)">
          {{DataService.SelectedDraw.Matches[NormalLimit+5].player1Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+7].player1) {
            <select id="POSelector81" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+7].player1" [ngChange]="updatePOLabel(8,1)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOP2" class="POPlayerLabel PO2" (click)="clearPOLabel(8,2)">
          {{DataService.SelectedDraw.Matches[NormalLimit+5].player2Name}}
          @if (!DataService.SelectedDraw.Matches[NormalLimit+7].player2) {
            <select id="POSelector82" name="POSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[NormalLimit+7].player2" [ngChange]="updatePOLabel(8,2)">
              @for (player of DataService.SelectedDraw.AvailablePlayers; track player) {
                <option [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
              }
            </select>
          }
        </label>
        <label id="RRPOW8" class="POWinnerLabel" (click)="enterPOScore(8)" name="{{NormalLimit+7}}" (mouseover)="RRmouseover($event,3);" (mouseleave)="RRshowScoreHover1 = false">{{DataService.SelectedDraw.Matches[NormalLimit+7].Winner}}</label>
        <label id="RRPOS8" class="POScoreLabel">{{DataService.SelectedDraw.Matches[NormalLimit+7].Score}}</label>
      </div>
    }
  </div>
}
@if (DataService.SelectedDraw?.format === 'PO' && DataService.SelectedDraw.Matches.length > 0) {
  <div id="ExtraMatches">
    @if (AllowTornUpdate == true && DataService.LoggedInUser.accessLevel > 1) {
      <div style="margin: 20px">
        <mat-button type="button" id="btnAddExtraMatch" name="btnAddExtraMatch" class="edit-toggle-btn" (click)="addExtraMatch()">Add Match</mat-button>
      </div>
    }
    @for (match of DataService.SelectedDraw.Matches; track match; let i = $index) {
      <div class="ExtraMatches ExtraMatchBox" style="display: inline-block; width: 400px">
        @if (AllowTornUpdate == true && DataService.LoggedInUser.accessLevel > 1) {
          <input type="button" id="btnDeleteEM{{i}}" name="btnDeleteEM" (click)="deleteMatch(match.matchNo)" value="X" style="float: right;" />
        }
        <label class="POPlayerLabel PO1">{{match.player1Name}}</label>
        <label class="POPlayerLabel PO2">{{match.player2Name}}</label>
        <label class="POWinnerLabel" (click)="EnterScore(match.matchNo)" (mouseover)="mouseover(match.matchNo)" (mouseleave)="mouseLeft()">{{match.Winner ? match.Winner.name + ' - ' + match.Score : match.dateOfMatch.toLocaleTimeString()}}</label>
      </div>
    }
    @if (DataService.SelectedMatch != null) {
      <app-score-edit class="KOScore"></app-score-edit>
    }
  </div>
}
<!-- <div *ngIf="DataService.SelectedDraw?.format === 'PO'" id="ExtraMatches">
<div *ngIf="AllowTornUpdate == true">
  <input type="button" id="btnAddExtraMatch" name="btnAddExtraMatch" (click)="addExtraMatch()" value="Add Match" />
  <input type="button" id="btnDeleteCurrentDraw" name="btnDeleteCurrentDraw" (click)="DeleteCurrentDraw()" value="Delete Draw" />
</div>
<div style="display: flex;">
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch1" *ngIf="DataService.SelectedDraw.Matches.length > 0">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM1" name="btnDeleteEM" (click)="deleteEM(1)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(1,1)">
      <select *ngIf="!DataService.SelectedDraw.Matches[0].player1" id="EMSelector11" name="EMSelector1" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[0].player1" [ngChange]="updateEMLabel(1,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>{{DataService.SelectedDraw.Matches[0].player1Name}}
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(1,2)">
      {{DataService.SelectedDraw.Matches[0].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[0].player2" id="EMSelector12" name="EMSelector2" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[0].player2" [ngChange]="updateEMLabel(1,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[0].Winner" id="EMW1D" class="POWinnerLabel" (click)="enterEMScore(1)">{{DataService.SelectedDraw.Matches[0].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[0].Winner" id="EMW1" class="POWinnerLabel" (click)="enterEMScore(1)">{{DataService.SelectedDraw.Matches[0].Winner}}</label>
    <label id="EMS1" class="POScoreLabel" (mouseover)="mouseover(1)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[0].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch2" *ngIf="DataService.SelectedDraw.Matches.length > 1">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM2" name="btnDeleteEM" (click)="deleteEM(2)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(2,1)">
      {{DataService.SelectedDraw.Matches[1].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[1].player1" id="EMSelector21" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[1].player1" [ngChange]="updateEMLabel(2,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(2,2)">
      {{DataService.SelectedDraw.Matches[1].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[1].player2" id="EMSelector22" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[1].player2" [ngChange]="updateEMLabel(2,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[1].Winner" id="EMW2D" class="POWinnerLabel" (click)="enterEMScore(2)">{{DataService.SelectedDraw.Matches[1].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[1].Winner" id="EMW2" class="POWinnerLabel" (click)="enterEMScore(2)">{{DataService.SelectedDraw.Matches[1].Winner}}</label>
    <label id="EMS2" class="POScoreLabel" (mouseover)="mouseover(2)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[1].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch3" *ngIf="DataService.SelectedDraw.Matches.length > 2">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM3" name="btnDeleteEM" (click)="deleteEM(3)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(3,1)">
      {{DataService.SelectedDraw.Matches[2].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[2].player1" id="EMSelector31" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[2].player1" [ngChange]="updateEMLabel(3,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(3,2)">
      {{DataService.SelectedDraw.Matches[2].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[2].player2" id="EMSelector32" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[2].player2" [ngChange]="updateEMLabel(3,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[2].Winner" id="EMW3D" class="POWinnerLabel" (click)="enterEMScore(3)">{{DataService.SelectedDraw.Matches[2].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[2].Winner" id="EMW3" class="POWinnerLabel" (click)="enterEMScore(3)">{{DataService.SelectedDraw.Matches[2].Winner}}</label>
    <label id="EMS3" class="POScoreLabel" (mouseover)="mouseover(3)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[2].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch4" *ngIf="DataService.SelectedDraw.Matches.length > 3">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM4" name="btnDeleteEM" (click)="deleteEM(4)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(4,1)">
      {{DataService.SelectedDraw.Matches[3].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[3].player1" id="EMSelector41" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[3].player1" [ngChange]="updateEMLabel(4,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(4,2)">
      {{DataService.SelectedDraw.Matches[3].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[3].player2" id="EMSelector42" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[3].player2" [ngChange]="updateEMLabel(4,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[3].Winner" id="EMW4D" class="POWinnerLabel" (click)="enterEMScore(4)">{{DataService.SelectedDraw.Matches[3].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[3].Winner" id="EMW4" class="POWinnerLabel" (click)="enterEMScore(4)">{{DataService.SelectedDraw.Matches[3].Winner}}</label>
    <label id="EMS4" class="POScoreLabel" (mouseover)="mouseover(4)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[3].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch5" *ngIf="DataService.SelectedDraw.Matches.length > 4">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM5" name="btnDeleteEM" (click)="deleteEM(5)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(5,1)">
      {{DataService.SelectedDraw.Matches[4].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[4].player1" id="EMSelector51" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[4].player1" [ngChange]="updateEMLabel(5,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(5,2)">
      {{DataService.SelectedDraw.Matches[4].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[4].player2" id="EMSelector52" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[4].player2" [ngChange]="updateEMLabel(5,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[4].Winner" id="EMW5D" class="POWinnerLabel" (click)="enterEMScore(5)">{{DataService.SelectedDraw.Matches[4].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[4].Winner" id="EMW5" class="POWinnerLabel" (click)="enterEMScore(5)">{{DataService.SelectedDraw.Matches[4].Winner}}</label>
    <label id="EMS5" class="POScoreLabel" (mouseover)="mouseover(5)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[4].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch6" *ngIf="DataService.SelectedDraw.Matches.length > 5">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM6" name="btnDeleteEM" (click)="deleteEM(6)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(6,1)">
      {{DataService.SelectedDraw.Matches[5].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[5].player1" id="EMSelector61" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[5].player1" [ngChange]="updateEMLabel(6,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(6,2)">
      {{DataService.SelectedDraw.Matches[5].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[5].player2" id="EMSelector62" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[5].player2" [ngChange]="updateEMLabel(6,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[5].Winner" id="EMW6D" class="POWinnerLabel" (click)="enterEMScore(6)">{{DataService.SelectedDraw.Matches[5].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[5].Winner" id="EMW6" class="POWinnerLabel" (click)="enterEMScore(6)">{{DataService.SelectedDraw.Matches[5].Winner}}</label>
    <label id="EMS6" class="POScoreLabel" (mouseover)="mouseover(6)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[5].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch7" *ngIf="DataService.SelectedDraw.Matches.length > 6">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM7" name="btnDeleteEM" (click)="deleteEM(7)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(7,1)">
      {{DataService.SelectedDraw.Matches[6].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[6].player1" id="EMSelector71" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[6].player1" [ngChange]="updateEMLabel(7,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(7,2)">
      {{DataService.SelectedDraw.Matches[6].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[6].player2" id="EMSelector72" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[6].player2" [ngChange]="updateEMLabel(7,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[6].Winner" id="EMW7D" class="POWinnerLabel" (click)="enterEMScore(7)">{{DataService.SelectedDraw.Matches[6].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[6].Winner" id="EMW7" class="POWinnerLabel" (click)="enterEMScore(7)">{{DataService.SelectedDraw.Matches[6].Winner}}</label>
    <label id="EMS7" class="POScoreLabel" (mouseover)="mouseover(7)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[6].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch8" *ngIf="DataService.SelectedDraw.Matches.length > 7">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM8" name="btnDeleteEM" (click)="deleteEM(8)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(8,1)">
      {{DataService.SelectedDraw.Matches[7].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[7].player1" id="EMSelector81" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[7].player1" [ngChange]="updateEMLabel(8,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(8,2)">
      {{DataService.SelectedDraw.Matches[7].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[7].player2" id="EMSelector82" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[7].player2" [ngChange]="updateEMLabel(8,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[7].Winner" id="EMW8D" class="POWinnerLabel" (click)="enterEMScore(8)">{{DataService.SelectedDraw.Matches[7].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[7].Winner" id="EMW8" class="POWinnerLabel" (click)="enterEMScore(8)">{{DataService.SelectedDraw.Matches[7].Winner}}</label>
    <label id="EMS8" class="POScoreLabel" (mouseover)="mouseover(8)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[7].Score}}</label>
  </div>
  <div class="ExtraMatches ExtraMatchBox" id="ExtraMatch9" *ngIf="DataService.SelectedDraw.Matches.length > 8">
    <input type="button" *ngIf="AllowTornUpdate == true" id="btnDeleteEM9" name="btnDeleteEM" (click)="deleteEM(9)" value="X" style="float: right;" />
    <label id="EMP1" class="POPlayerLabel PO1" (click)="clearEMLabel(9,1)">
      {{DataService.SelectedDraw.Matches[8].player1Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[8].player1" id="EMSelector91" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[8].player1" [ngChange]="updateEMLabel(9,1)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name : player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label id="EMP2" class="POPlayerLabel PO2" (click)="clearEMLabel(9,2)">
      {{DataService.SelectedDraw.Matches[8].player2Name}}
      <select *ngIf="!DataService.SelectedDraw.Matches[8].player2" id="EMSelector92" name="EMSelector" class="ManualSelects PO" [(ngModel)]="DataService.SelectedDraw.Matches[8].player2" [ngChange]="updateEMLabel(9,2)">
        <option *ngFor="let player of DataService.SelectedDraw.AvailablePlayers" [ngValue]="player.id">{{DataService.SelectedDraw.theEvent.type === 'Singles'?player.name:player.name + '/' + player.PartnerName}}</option>
      </select>
    </label>
    <label *ngIf="!DataService.SelectedDraw.Matches[8].Winner" id="EMW9D" class="POWinnerLabel" (click)="enterEMScore(9)">{{DataService.SelectedDraw.Matches[8].dateOfMatch.toLocaleTimeString()}}</label>
    <label *ngIf="!DataService.SelectedDraw.Matches[8].Winner" id="EMW9" class="POWinnerLabel" (click)="enterEMScore(9)">{{DataService.SelectedDraw.Matches[8].Winner}}</label>
    <label id="EMS9" class="POScoreLabel" (mouseover)="mouseover(9)" (mouseleave)="HoveredMatch = null">{{DataService.SelectedDraw.Matches[8].Score}}</label>
  </div>
</div>
</div> -->

